import { useMemo } from 'react';

import { Bubble } from './Bubble';
import { BubbleVariant } from './BubbleVariant';

type TopicBubbleProps = {
  topic: Topic;
  count: number;
  onClick: (id: TopicId) => void;
  active: boolean;
};

export function TopicBubble({ topic, count = 0, onClick, active }: TopicBubbleProps) {
  const variant = useMemo(() => {
    if (active && count > 0) {
      return BubbleVariant.ActiveWithCount;
    }
    if (active) {
      return BubbleVariant.Active;
    }
    if (count > 0) {
      return BubbleVariant.DefaultWithCount;
    }
    return BubbleVariant.Default;
  }, [active, count]);

  return (
    <Bubble count={count} label={topic.label} onClick={() => onClick(topic.id)} variant={variant} color={topic.color} />
  );
}
